/* eslint-disable @typescript-eslint/no-explicit-any */
import { useState, useEffect } from 'react';
import { canUseDOM } from '@/app/common/utils/canUseDOM';

export const getWindowDimensions = (): { width?: number; height?: number } => {
  if (canUseDOM) {
    const { innerWidth: width } = window;
    return { width };
  }

  return {
    width: 768,
  };
};

const useWindowDimensions = (): any => {
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

  useEffect(() => {
    const handleResize = (): void => {
      if (canUseDOM) {
        if (windowDimensions.width !== window.innerWidth) {
          setWindowDimensions(getWindowDimensions());
        }
      }
    };

    window.addEventListener('resize', handleResize);
    return (): any => {
      if (canUseDOM) window.removeEventListener('resize', handleResize);
    };
  }, []);

  return windowDimensions;
};

export default useWindowDimensions;
